import './chip.scss'

export default (props) => {

    const {
        error,
        displayError,
        message,
        helpertext,
        label,
        tooltip,
        ...inputProps } = props

    return (

        <label
            htmlFor={props.id || props.name}
            className={` input-chip ${props.className} `}
            style={props.style}>
            <input
                id={props.id || props.name}
                type="checkbox"
                {...inputProps}
            />
            <span className="group">
            {props.leadingIcon === true &&
                    <span className="icon-leading icon-checked">
                        <span className="icon medium"
                            style={{
                                WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/checkmark.svg)",
                                maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/checkmark.svg)",
                                color: "currentColor"
                            }}>
                        </span>
                    </span>
                }
                <span className="label-inline">
                    {props.label}
                </span>
                {props.trailingIcon !== false &&
                    <span className="icon-trailing icon-checked">
                        <span className="icon medium"
                            style={{
                                WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)",
                                maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)",
                                color: "currentColor"
                            }}>
                        </span>
                    </span>
                }

            </span>
        </label>
    )
}